import { useNavigate } from "react-router-dom";
import ForgotPasswordPopup from "./forgot-password-popup";
import { routes } from "../../../constants/routes";

const PreneedForgotPasswordPage = () => {
  const navigate = useNavigate();

  return (
    <ForgotPasswordPopup
      open={true}
      onClose={() => navigate(routes.PRENEED_LOGIN)}
      onBackToLogin={() => navigate(routes.PRENEED_LOGIN)}
    />
  );
};

export default PreneedForgotPasswordPage;
